export type ReposicionDeliveryReadinessInput = {
  beneficiarioNombre?: string;
  beneficiarioDocumento?: string;
  firmaMediaId?: string | null;
  fotoMediaId?: string | null;
};

export type ReposicionDeliveryReadinessIssue = {
  message: string;
};

export function reposicionDeliveryLabel(input: ReposicionDeliveryReadinessInput): string {
  const name = input.beneficiarioNombre?.trim();
  const doc = input.beneficiarioDocumento?.trim();
  if (name && doc) return `${name} (${doc})`;
  return name || doc || 'Reposición';
}

/** Firma/foto optional for sync/export/PDF — never block. */
export function reposicionDeliveryReadinessIssues(
  _input: ReposicionDeliveryReadinessInput,
): ReposicionDeliveryReadinessIssue[] {
  return [];
}

/** Non-blocking: missing firma/foto. */
export function reposicionDeliveryMediaWarnings(
  input: ReposicionDeliveryReadinessInput,
): ReposicionDeliveryReadinessIssue[] {
  const missing: string[] = [];
  if (!input.firmaMediaId?.trim()) missing.push('firma');
  if (!input.fotoMediaId?.trim()) missing.push('foto');
  if (missing.length === 0) return [];
  return [{ message: `${reposicionDeliveryLabel(input)} sin ${missing.join(' ni ')}.` }];
}

export function formatReposicionDeliveryReadinessMessage(
  issues: ReposicionDeliveryReadinessIssue[],
  opts?: { beneficiarioNombre?: string; action?: 'pdf' | 'sync' },
): string {
  if (issues.length === 0) return '';
  const action = opts?.action === 'sync' ? 'sincronizar' : 'generar el PDF';
  const beneficiario = opts?.beneficiarioNombre?.trim();
  const head = beneficiario
    ? `No se puede ${action} la reposición de «${beneficiario}»:`
    : `No se puede ${action}:`;
  return `${head} ${issues.map((issue) => issue.message).join(' ')}`;
}

export function formatReposicionDeliveryWarningMessage(
  issues: ReposicionDeliveryReadinessIssue[],
  opts?: { beneficiarioNombre?: string },
): string {
  if (issues.length === 0) return '';
  const beneficiario = opts?.beneficiarioNombre?.trim();
  const head = beneficiario ? `Advertencia en la reposición de «${beneficiario}»:` : 'Advertencia:';
  return `${head} ${issues.map((issue) => issue.message).join(' ')}`;
}
